import { render, staticRenderFns } from "./CogdiffResponse.vue?vue&type=template&id=532e0d7d&scoped=true&"
import script from "./CogdiffResponse.vue?vue&type=script&lang=js&"
export * from "./CogdiffResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e0d7d",
  null
  
)

export default component.exports